import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Button } from 'reactstrap'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'
import localization from 'moment/locale/de'

import { trackGAEvent } from '../utilities/tracking'
import { getPlant } from '../../actions'
import { PLANTS } from '../../constants/routes'
import { isDefaultSensorImage } from '../utilities/helpers'
import {
    TabsContentHeader,
    TabsContentHeadline,
    TabsContainer
} from '../StyledComponents/Plants/PlantTabs'
import {
    DeviceDetailsImage,
    DeviceDetailsName,
    DeviceDetailsLastUpdate,
    DeviceDetailsOverview,
    DeviceDetailsOverviewIcon,
    DeviceDetailsOverviewText,
    AddPlantIcon
} from '../StyledComponents/Devices/DeviceDetails'
import PlantListItem from '../Plant/PlantListItem'
import MoistureChart from './MoistureChart'
import InfoModal from '../Global/InfoModal'

import { FillerDiv, CenteredDivWithMargin } from '../StyledComponents/Fillers'

const batteryGreen = require('../../assets/images/DevicesList/batteryGreenFilled.svg')
const batteryOrange = require('../../assets/images/DevicesList/batteryOrangeFilled.svg')
const batteryRed = require('../../assets/images/DevicesList/batteryRedFilled.svg')
const sensorImage = require('../../assets/images/DevicesList/sensor.png')
const moistureIcon = require('../../assets/images/CareIcons/005-drop.png')

class SensorDetails extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showDeleteModal: false,
            measurementClicked: false,
        }

        this.onAddPlantClicked = this.onAddPlantClicked.bind(this)
        this.loadPlants = this.loadPlants.bind(this)
        this.onChartClicked = this.onChartClicked.bind(this)
    }

    componentDidMount() {
        this.loadPlants()
        window.scrollTo(0, 0)
    }

    onAddPlantClicked() {
        const { history, onAddPlant, device } = this.props

        trackGAEvent('interaction', {
            interaction_value: 'undefined',
            interaction_category: 'Sensor-Details',
            interaction_action: 'add-plant-button-click',
            interaction_label: 'add plant',
        })

        onAddPlant(device.uuid)
        history.push(PLANTS)
    }

    onChartClicked() {
        if (!this.state.measurementClicked) {
            this.setState({ measurementClicked: true })
            trackGAEvent('interaction', {
                interaction_value: 'undefined',
                interaction_category: 'Sensor-Details',
                interaction_action: 'measurement-click',
                interaction_label: `${this.props.device.uuid}`,
            })
        }
    }

    loadPlants() {
        const { plants, device, loadPlant } = this.props
        const sensorPlants = device.plants

        if (!!device && !isEmpty(sensorPlants)) {
            sensorPlants.forEach((plantId) => {
                if (!plants[plantId]) {
                    loadPlant(plantId)
                }
            })
        }
    }

    render() {
        const { device, onRemovePlant, onRemoveSensor } = this.props
        const { soc } = device

        let batteryIcon = null
        let batteryColor = 'black'
        if (soc < 20) {
            batteryIcon = batteryRed
            batteryColor = 'danger'
        } else if (soc < 50) {
            batteryIcon = batteryOrange
            batteryColor = 'warning'
        } else {
            batteryIcon = batteryGreen
            batteryColor = 'success'
        }

        const image = isEmpty(device.image) ? sensorImage : device.image

        const sensorPlants = !isEmpty(device.plants)
            ? device.plants.map((plantId) => {
                const sensorPlant = this.props.plants[plantId] || null
                return sensorPlant ? (
                    <PlantListItem style={{ margin: '0' }} plant={sensorPlant} key={plantId} showDelete onPlantRemove={onRemovePlant} />
                ) : null
            }, this) : null

        const deleteWarning = this.state.showDeleteModal ? (<InfoModal
            text="Bist du dir sicher, dass du diesen Sensor aus deiner Geräteliste löschen möchtest?"
            headerText="Achtung"
            isOpen
            actionText="Löschen"
            secondaryText="Abbrechen"
            closeModal={() => {
                this.setState({ showDeleteModal: false })
                onRemoveSensor(device.uuid)
            }}
            secondaryAction={() => this.setState({ showDeleteModal: false })}
        />) : null


        return (
            <FillerDiv>
                {deleteWarning}
                <DeviceDetailsImage
                    contain={isDefaultSensorImage(device.image)}
                    src={image}
                    alt={device.name}
                />
                <DeviceDetailsName>{device.name}</DeviceDetailsName>
                <DeviceDetailsLastUpdate>{`${moment(device.last_measure_date).locale('de', localization).calendar()}`}</DeviceDetailsLastUpdate>
                <FillerDiv className="container">
                    <DeviceDetailsOverview className="row">
                        <FillerDiv className="col-6">
                            <DeviceDetailsOverviewIcon src={moistureIcon} alt="Bodenfeuchte" />
                            <DeviceDetailsOverviewText>
                                {device.current_moisture}%
                            </DeviceDetailsOverviewText>
                        </FillerDiv>
                        <FillerDiv className="col-6">
                            <DeviceDetailsOverviewIcon src={batteryIcon} alt="Akkustand" />
                            <DeviceDetailsOverviewText color={batteryColor}>
                                {device.soc}%
                            </DeviceDetailsOverviewText>
                        </FillerDiv>
                    </DeviceDetailsOverview>
                </FillerDiv>
                <FillerDiv>
                    <TabsContainer>
                        <TabsContentHeader>
                            <TabsContentHeadline margin="0 0 15px 0">Pflanzen</TabsContentHeadline>
                            <AddPlantIcon name="plus" size="lg" onClick={this.onAddPlantClicked} />
                            {sensorPlants}
                        </TabsContentHeader>
                        <TabsContentHeader margin="40px 0">
                            <TabsContentHeadline>Messwerte</TabsContentHeadline>
                            <MoistureChart
                                onMeasurementClick={this.onChartClicked}
                                data={device.data}
                            />
                        </TabsContentHeader>
                    </TabsContainer>
                </FillerDiv>
                <CenteredDivWithMargin bottom="30">
                    <Button color="danger" onClick={() => this.setState({ showDeleteModal: true })}>Sensor löschen</Button>
                </CenteredDivWithMargin>
            </FillerDiv>
        )
    }
}

const mapStateToProps = state => ({
    plants: state.plants,
})

export default compose(
    withRouter,
    connect(mapStateToProps, {
        loadPlant: getPlant,
    })
)(SensorDetails)



// WEBPACK FOOTER //
// ./src/components/Devices/SensorDetails.js